module.exports = __webpack_public_path__ + "static/media/checklist_512.4a39deae.png";